import { render, staticRenderFns } from "./MenteeTableCpt.vue?vue&type=template&id=a1d3630e&scoped=true&"
import script from "./MenteeTableCpt.vue?vue&type=script&lang=ts&"
export * from "./MenteeTableCpt.vue?vue&type=script&lang=ts&"
import style0 from "./MenteeTableCpt.vue?vue&type=style&index=0&id=a1d3630e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d3630e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VContainer,VSimpleTable})
